import React from 'react';
import CommonBanner from "../component/Common/CommonBanner";
// import { ImageConstants } from '../../../assets/img/ImageConstants';
import { ImageConstants } from "../assets/img/ImageConstants";
import DiscountArea from '../component/About/DiscountArea';
import CorporateTravelText from '../component/Services/corporateTravel';
import BookYourTravel from '../component/BookYourTravel';

const CorporateTravel = () => {
  return (
    <>
      <CommonBanner
        heading="Corporate Travel"
        img={ImageConstants.corporatetravelheadbanner}
        pagination="Corporate Travel"
      />
      <CorporateTravelText />
      <DiscountArea
        smallImg={ImageConstants.corporatetravelsmalll}
        largeImg={ImageConstants.corporatetravellarge}
      />
      <BookYourTravel />
    </>
  );
};

export default CorporateTravel;
